'use strict';

import React         from 'react';
import {Link}        from 'react-router';
import DocumentTitle from 'react-document-title';
import MyProfileStore from '../../stores/MyProfileStore';
import * as Connections from "../../utils/Connections.js";
import $ from "jquery";
import * as Cookies from "../../utils/Cookies";
const tempStyle = {
    marginBottom: '0px'
};
export default class Profile extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            profile: {},
            imageData:'',
            imageExt:''
        }
        this.updateUserDetails=this.updateUserDetails.bind(this);
        this.loadSelectedImage=this.loadSelectedImage.bind(this);
        this.uploadImage=this.uploadImage.bind(this);
        this.getSecureImage=this.getSecureImage.bind(this);

    }
    uploadImage(){
        var sendData={
            method:'POST',
            headers:new Headers({
                'Content-Type':'application/x-www-form-urlencoded'
            }),
            body:$.param({
                type:"updateImage",
                token:Cookies.checkCookie("accessToken"),
                imgData:this.state.imageData,
                ext:this.state.imageExt
            })

        };
        Connections.updateImage(sendData);
    }
    updateUserDetails(){
        this.setState({
            profile:MyProfileStore.getProfileData()
        });
        // document.getElementById("updateImageUpload").style.display = "none";

    }
    loadSelectedImage(event){
        console.log(event);
        var selectedFile = event.target.files[0];
        var reader = new FileReader();

        var imgtag = document.getElementById("myimage");
        imgtag.title = "";
        var self=this;
        reader.onload = function(event) {
            imgtag.src = event.target.result;
            // console.log(imgtag.src);
            var processing=imgtag.src.split(';')[0].split('/')[1];

            self.setState({
                imageData:imgtag.src.replace(/^data:image\/(png|jpg);base64,/, ''),
                imageExt:processing
            });
            document.getElementById("updateImageUpload").style.display = "block";
        };

        reader.readAsDataURL(selectedFile);
    }
    componentWillMount() {
        this.setState({
            profile:MyProfileStore.getProfileData()
        });
        MyProfileStore.on("change",this.updateUserDetails);
        Connections.getMyProfileEdit();
    }
    getSecureImage(image){
            return image.replace("http://", "https://");
    }
    render() {
        return (
            <DocumentTitle title="Khula - User Profile">
                <div className="main-content">
                    <div style={{minHeight: '80vh'}} className="container-fluid">
                        <div className="panel panel-profile">
                            <div className="clearfix">
                                <div className="profile-left">
                                    <div style={tempStyle} className="col-sm-12 col-xs-12 col-lg-12 col-md-12">
                                        <div className="wrapper uk-card uk-card-hover" style={{backgroundColor: 'white', marginTop:'15px'}}>
                                            <div className="card radius shadowDepth1">
                                                <div style={{height: '300px'}} className="card__image border-tlr-radius">
                                                    <input type="file"  onChange={(e) => this.loadSelectedImage(e)}/>
                                                    <img  src={this.getSecureImage(this.state.profile.picture)} id="myimage" alt="" className="border-tlr-radius" />
                                                </div>

                                                <button type="submit" id="updateImageUpload" className="btn btn-primary btn-lg btn-block" onClick={this.uploadImage}>Update Image</button>
                                                {/*<input type="submit" value="Update Image" onClick={this.uploadImage()}/>*/}
                                                {/*<div className="card__content card__padding">*/}
                                                {/*<article className="card__article">*/}
                                                {/*/!*<h4>{this.state.profile.name}</h4>*!/*/}
                                                {/*<div className="card__meta">*/}
                                                {/*/!*<time>{this.state.profile.location}</time>*!/*/}
                                                {/*</div>*/}

                                                {/*<br/>*/}
                                                {/*</article>*/}
                                                {/*</div>*/}
                                            </div>

                                        </div>

                                    </div>
                                </div>





                                <div className="profile-right">
                                    <table className="uk-table uk-table-middle uk-table-divider">
                                        <thead>
                                        <tr>
                                            <th className="uk-table-expand"></th>
                                            <th className="uk-table-expand"></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td>Full Name</td>
                                            <td><strong>{this.state.profile.name}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>Phone no.</td>
                                            <td><strong>{this.state.profile.phone}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>Email</td>
                                            <td><strong>{this.state.profile.email}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>Location</td>
                                            <td><strong>{this.state.profile.location}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>Completed Orders</td>
                                            <td><strong>{this.state.profile.completed}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>Pending Orders</td>
                                            <td><strong>{this.state.profile.pending}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>Favorite Farmers</td>
                                            <td><strong>{this.state.profile.farmers}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>Registration Date</td>
                                            <td><strong>{this.state.profile.joined}</strong></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </DocumentTitle>
        );
    }

}



// WEBPACK FOOTER //
// ./src/pages/HopePageBabies/Profile.js